import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {ApiClientConfig} from '../api-client-config';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {
  ListPermissionRuleResponse
} from "it/primatoo/openapi/api/org/schemas/permissionrule/ListPermissionRuleResponse";
import {Rule} from "it/primatoo/openapi/api/org/schemas/permissionrule/listpermissionruleresponse/Rule";
import {map} from "rxjs/operators";
import {PermissionRule} from "it/primatoo/openapi/api/org/schemas/permissionrule/PermissionRule";
import {
  CreatePermissionRuleRequest
} from "it/primatoo/openapi/api/org/schemas/permissionrule/CreatePermissionRuleRequest";
import {CreateResponse} from "it/primatoo/openapi/api/common/schemas/CreateResponse";
import {
  UpdatePermissionRuleRequest
} from "it/primatoo/openapi/api/org/schemas/permissionrule/UpdatePermissionRuleRequest";
import {ListUserColumnsResponse} from "it/primatoo/openapi/api/org/schemas/common/ListUserColumnsResponse";
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';
import {UpsertUserColumnRequest} from "it/primatoo/openapi/api/org/schemas/common/UpsertUserColumnRequest";

@Injectable({
  providedIn: 'root'
})
export class PermissionRulesService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/v2/permissions/rules/';
  }

  // @Mock({
  //   response: {
  //     kind: 'jsonFile',
  //     fileName: 'ListPermissionRuleResponse',
  //     overrides: (response: ListPermissionRuleResponse) => response.rules ?? []
  //   }
  // })
  public getPermissionRules(): Observable<Rule[]> {
    const url = this.endpoint;
    return this.httpClient.get<ListPermissionRuleResponse>(url).pipe(
      map((response) => response.rules ?? [])
    );
  }

  // @Mock({response: {kind: 'jsonFile', fileName: 'FindPermissionRuleResponse'}})
  public getPermissionRuleById(id: number): Observable<PermissionRule> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<PermissionRule>(url);
  }

  // @Mock({response: {kind: 'httpOk200'}})
  public createPermissionRule(requestBody: CreatePermissionRuleRequest): Observable<CreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<CreateResponse>(url, requestBody);
  }

  // @Mock({response: {kind: 'httpOk200'}})
  public updatePermissionRule(id: number, requestBody: UpdatePermissionRuleRequest): Observable<void> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<void>(url, requestBody);
  }

  // @Mock({response: {kind: 'httpOk200'}})
  // public deletePermissionRule(id: number): Observable<void> {
  //   const url = this.endpoint + id + '/';
  //   return this.httpClient.delete<void>(url);
  // }

  public getEndPointV1(): string {
    return this.endpoint;
  }

  public setPriority(id: number, request: PriorityPatchRequest): Observable<void> {
    // const url = `${this.endpoint}${id}/priority`;
    // return this.httpClient.patch<Damage>(url, request);
    return of();
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns/`;
    return this.httpClient.get<ListUserColumnsResponse>(url).pipe(map(m => m.columns as ColumnWithLocalization[]));
  }

  public updateUserColumns(columnsConfigurationUpsertRequest: UpsertUserColumnRequest): Observable<void> {
    const url = this.endpoint + 'user-columns';
    return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  }
}
